

export default function test2() {
	return <button onClick={() => {throw new Error("This is your first error!");}}>Break the world</button>;
}